export default __webpack_public_path__ + "static/media/logo.125d7d2b.png";